import Swiper from 'https://unpkg.com/swiper@7/swiper-bundle.esm.browser.min.js';

// core version + navigation, pagination modules:

const swiper_nav = new Swiper(".product_gallery__nav", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 6,
  freeMode: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true
});
const swiper = new Swiper(".product_gallery", {
  loop: true,
  autoHeight: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
  // modules: [Navigation, Thumbs],
  thumbs: {
    swiper: swiper_nav
  } // onAny(eventName, ...args) {
  //   console.log('Event: ', eventName);
  //   console.log('Event data: ', args);
  // }

});
const selector = document.querySelector('.product-form input[name="id"]');
selector.addEventListener("change", e => {
  const slide = document.querySelector(`[data-slide-id="${selector.value}"]`);
  let slide_index = slide.dataset.swiperSlideIndex;
  swiper.slideToLoop(parseInt(slide_index));
});
